export default __webpack_public_path__ + "ffb52f5060054882dfa799101592cb89.svg";